import { render, staticRenderFns } from "./InputKeyValuePairs.vue?vue&type=template&id=34ac87bb"
import script from "./InputKeyValuePairs.vue?vue&type=script&lang=js"
export * from "./InputKeyValuePairs.vue?vue&type=script&lang=js"
import style0 from "./InputKeyValuePairs.vue?vue&type=style&index=0&id=34ac87bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports